export default __webpack_public_path__ + "static/media/c1.d350964b.jpg";